import CustomizedBadges from "./customizedBadges.component";

export default CustomizedBadges;